import React from "react"

export default function Girls({
  strokeDasharray,
  strokeDashoffset = 78.54,
  className,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 105 105"
      className={className}
      fill="none"
    >
      <path
        fill="#000"
        d="M50.4 40.2c.5-.7 1.4-3.5 3.2-3.4 1.6 0 1.7 1.5 1.7 1.7 0 2.5-3.6 2.4-4.9 1.7zm15.4 25.1v10.6h-3V65.3h-3.6v10.6h-3V65.3h-4.8l3-11.5v-6.2c0-3.7 3-6.6 6.6-6.6 3.7 0 6.6 3 6.6 6.6v6.3l3 11.4h-4.8zm-10.5-3h11.3L64.5 54v-6.4c0-2-1.6-3.6-3.6-3.6s-3.6 1.6-3.6 3.6l-.1 6.9-1.9 7.8zm-1.2-28.4c0-3.8 3.1-6.8 6.8-6.8s6.8 3.1 6.8 6.8c0 3.8-3.1 6.8-6.8 6.8-3.7 0-6.8-3.1-6.8-6.8zm10.6 0c0-.2 0-.5-.1-.7-1.5-.1-2.9-.9-3.9-1.7-1.1 1.2-2.6 1.9-3.6 2.3v.1c0 2.1 1.7 3.8 3.8 3.8 2.1-.1 3.8-1.8 3.8-3.8zm-31.2 42h3V60.1h-3v15.8zm6.6 0h3V60.1h-3v15.8zM38.4 41c-4.3 0-7.9 3.5-7.9 7.9v11.2h15.7V48.9c0-4.4-3.5-7.9-7.8-7.9zm-6.9-7.1c0-3.8 3.1-6.8 6.8-6.8 3.8 0 6.8 3.1 6.8 6.8 0 3.8-3.1 6.8-6.8 6.8-3.7 0-6.8-3.1-6.8-6.8zm10.6 0v-.4c-1.8-.2-4-1.2-5.5-2.5L35 32.3c-.2.5-.4 1-.4 1.6 0 2.1 1.7 3.8 3.8 3.8 2-.1 3.7-1.8 3.7-3.8z"
      />

      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
        d="M50 5a45 45 0 110 90 45 45 0 010-90h0z"
      />
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke="hsl(var(--color-kkm-yellow))"
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </svg>
  )
}
